import { IconProps } from '../Icons.type'

export function PinOffIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
      stroke="#8F8F8F"
      {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 17.04v5m3-12.66V7.04a1 1 0 011-1 2 2 0 000-4H7.89M2 2.04l20 20m-13-13v1.76a2 2 0 01-1.11 1.79l-1.78.9A2 2 0 005 15.28v.76a1 1 0 001 1h11"></path>
    </svg>
  )
}
